import { render, staticRenderFns } from "./dacIndex.vue?vue&type=template&id=0c2cfabc&"
import script from "./dacIndex.vue?vue&type=script&lang=js&"
export * from "./dacIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports